import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getTabelasPrecos(context, dados) {
        if((!dados.pagina) || (!dados.quantidadePorPagina)) {
            dados.pagina = 1;
            dados.quantidadePorPagina = 25;
        }
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("tabelasPrecos/access/listar", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getTabelaPreco(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("tabelasPrecos/access/obter", {ID_PRECO_PRODUTO: dados.id, componente: dados.componente}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getTabelaPrecoSimples(context, idTabelaPreco) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("tabelasPrecos/access/obterSimples", {ID_PRECO_PRODUTO: idTabelaPreco}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getTabelaPrecoBox(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("tabelasPrecos/access/listaBox", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getTabelaPrecoProdutos(context, idTabelaPreco) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("tabelasPrecos/access/listarProdutos", {ID_PRECO_PRODUTO: idTabelaPreco}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    deleteTabelaPreco(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("tabelasPrecos/access/excluir", {ID_PRECO_PRODUTO: dados.id, componente: dados.componente}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    async postTabelaPreco(context, tabelapreco) {
        if (!JwtService.getToken()) {
            throw new Error("Sessão expirada. Entre novamente para salvar a tabela de preço.");
        }
        ApiService.setHeader();
        const { data } = await ApiService.postOnce("tabelasPrecos/access/salvar", tabelapreco);
        return data;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
